{
  "familyId": "GET-NEGATIEF-PLUS",
  "questions": [
    {
      "id": "GET-NEGATIEF-PLUS-001",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is −3 + 7?",
      "options": ["4", "−4", "10", "−10"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -4,
            "end": 5,
            "marked": [-3],
            "step": 1,
            "label": "Begin bij −3 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen bij een negatief getal",
            "content": "Begin bij −3 op de getallenlijn en ga 7 stappen naar rechts (optellen = naar rechts). Je passeert 0 en komt op 4.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": -4,
            "end": 5,
            "marked": [-3],
            "highlight": [4],
            "arrows": [{"from": -3, "to": 4, "label": "7 stappen naar rechts"}],
            "step": 1,
            "label": "−3 + 7 = 4: je passeert 0 en komt op 4"
          }
        }
      ],
      "conceptId": "negatief_plus_positief",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Begin bij −3 op de getallenlijn en ga 7 stappen naar rechts. Je passeert 0 en komt op 4. Het positieve getal (7) is groter dan het negatieve (3), dus het antwoord is positief.",
        "solutionSteps": [
          "Begin bij −3 op de getallenlijn",
          "Ga 7 stappen naar rechts (optellen)",
          "−3 → −2 → −1 → 0 → 1 → 2 → 3 → 4",
          "Antwoord: −3 + 7 = 4"
        ],
        "distractorExplanations": {
          "0": "Goed! −3 + 7 = 4. Je begint bij −3 en gaat 7 naar rechts, voorbij 0.",
          "1": "Je dacht waarschijnlijk dat het antwoord negatief moet zijn omdat je met een negatief getal begint. Maar 7 is groter dan 3, dus je komt boven nul uit: −3 + 7 = 4. Onthoud: als het positieve getal groter is, wordt het antwoord positief.",
          "2": "Je dacht waarschijnlijk dat je de getallen gewoon optelt: 3 + 7 = 10. Maar −3 + 7 is niet hetzelfde als 3 + 7. Je begint 3 onder nul, dus je komt op 7 − 3 = 4. Onthoud: het minteken betekent dat je lager begint.",
          "3": "Je dacht waarschijnlijk dat beide getallen negatief worden: −3 + (−7) = −10. Maar het is −3 + 7 (positief), niet −3 + (−7). Onthoud: een positief getal optellen betekent naar rechts gaan op de getallenlijn."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-002",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is −5 + (−3)?",
      "options": ["−8", "−2", "8", "2"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -9,
            "end": 0,
            "marked": [-5],
            "step": 1,
            "label": "Begin bij −5 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee negatieve getallen optellen",
            "content": "Als je twee negatieve getallen optelt, ga je nóg verder naar links. −5 + (−3): begin bij −5 en ga 3 stappen naar links → −8. Twee negatieve getallen optellen geeft een nóg negatiever getal.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": -9,
            "end": 0,
            "marked": [-5],
            "highlight": [-8],
            "arrows": [{"from": -5, "to": -8, "label": "3 stappen naar links"}],
            "step": 1,
            "label": "−5 + (−3) = −8: verder onder nul"
          }
        }
      ],
      "conceptId": "negatief_plus_negatief",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Begin bij −5 op de getallenlijn en ga 3 stappen naar links (een negatief getal optellen = naar links). −5 + (−3) = −8. Je kunt het ook zo zien: 5 + 3 = 8, en beide zijn negatief, dus −8.",
        "solutionSteps": [
          "Begin bij −5 op de getallenlijn",
          "Tel −3 op → ga 3 stappen naar links",
          "−5 + (−3) = −(5 + 3) = −8",
          "Antwoord: −8"
        ],
        "distractorExplanations": {
          "0": "Goed! −5 + (−3) = −8. Twee negatieve getallen optellen geeft een nóg negatiever getal.",
          "1": "Je dacht waarschijnlijk dat je moet aftrekken: −5 − (−3) = −5 + 3 = −2. Maar de vraag is optellen: −5 + (−3). Een negatief getal optellen is hetzelfde als aftrekken. Onthoud: −5 + (−3) = −5 − 3 = −8.",
          "2": "Je dacht waarschijnlijk dat de mintekens wegvallen: 5 + 3 = 8. De uitkomst is inderdaad 8, maar negatief: −8. Onthoud: twee negatieve getallen optellen geeft altijd een negatief antwoord.",
          "3": "Je dacht waarschijnlijk dat −5 + (−3) hetzelfde is als −5 + 3 = −2, en dan zonder minteken: 2. Maar (−3) is negatief, niet positief. Onthoud: let goed op de haakjes — (−3) betekent min 3."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-003",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "thermometer_slider",
      "question": "De temperatuur is −8°C. Het wordt 12 graden warmer. Wat is de nieuwe temperatuur?",
      "options": [],
      "correctAnswer": 4,
      "data": {
        "minTemp": -15,
        "maxTemp": 15,
        "startTemp": -8,
        "step": 1,
        "unit": "C"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "minTemp": -15,
            "maxTemp": 15,
            "currentTemp": -8,
            "targetTemp": 4,
            "unit": "C",
            "label": "Van −8°C naar 4°C: 12 graden stijging"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Temperatuurstijging = optellen",
            "content": "Het wordt 12 graden warmer. Dat betekent: −8 + 12. Begin bij −8 en ga 12 stappen omhoog op de thermometer. Je passeert 0 en komt op 4°C.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_context",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De temperatuur begint bij −8°C en stijgt 12 graden. Stijging betekent optellen: −8 + 12. Begin bij −8 en ga 12 stappen naar rechts. Je passeert 0 en komt op 4°C. Het wordt warmer dan 0 graden!",
        "solutionSteps": [
          "Begint bij −8°C",
          "Stijging van 12 graden = optellen: −8 + 12",
          "12 − 8 = 4 (positief, want 12 > 8)",
          "Antwoord: 4°C"
        ]
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-004",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 6 + (−9)?",
      "options": ["−3", "3", "−15", "15"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": -4,
            "end": 7,
            "marked": [6],
            "step": 1,
            "label": "Begin bij 6 op de getallenlijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een negatief getal optellen = aftrekken",
            "content": "Een negatief getal optellen is hetzelfde als aftrekken. 6 + (−9) = 6 − 9. Begin bij 6 en ga 9 stappen naar links: je komt op −3.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": -4,
            "end": 7,
            "marked": [6],
            "highlight": [-3],
            "arrows": [{"from": 6, "to": -3, "label": "9 stappen naar links"}],
            "step": 1,
            "label": "6 + (−9) = 6 − 9 = −3"
          }
        }
      ],
      "conceptId": "positief_plus_negatief",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Een negatief getal optellen is hetzelfde als aftrekken: 6 + (−9) = 6 − 9. Begin bij 6 en ga 9 stappen naar links. Je gaat voorbij 0 en komt op −3.",
        "solutionSteps": [
          "Herken: een negatief getal optellen = aftrekken",
          "6 + (−9) = 6 − 9",
          "Begin bij 6, ga 9 naar links → voorbij 0",
          "6 − 9 = −3"
        ],
        "distractorExplanations": {
          "0": "Goed! 6 + (−9) = 6 − 9 = −3.",
          "1": "Je dacht waarschijnlijk dat je 9 − 6 = 3 rekent (positief). Het verschil is inderdaad 3, maar omdat je meer aftrekt dan je hebt, wordt het negatief: −3. Onthoud: als het negatieve getal groter is, wordt het antwoord negatief.",
          "2": "Je dacht waarschijnlijk dat je de getallen optelt met een minteken: −(6 + 9) = −15. Maar 6 + (−9) = 6 − 9, niet −(6 + 9). Onthoud: een negatief getal optellen = aftrekken, niet alles negatief maken.",
          "3": "Je dacht waarschijnlijk dat je de getallen gewoon optelt: 6 + 9 = 15. Maar (−9) is negatief, dus je trekt af: 6 − 9 = −3. Onthoud: let op het minteken in de haakjes."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-005",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "thermometer_slider",
      "question": "De thermometer geeft −6°C aan. In de loop van de dag stijgt de temperatuur 10 graden. Wat wordt de temperatuur?",
      "options": [],
      "correctAnswer": 4,
      "data": {
        "minTemp": -15,
        "maxTemp": 15,
        "startTemp": -6,
        "step": 1,
        "unit": "C"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "thermometer",
          "showWhen": "wrong",
          "data": {
            "minTemp": -15,
            "maxTemp": 15,
            "currentTemp": -6,
            "targetTemp": 4,
            "unit": "C",
            "label": "Van −6°C naar 4°C: 10 graden stijging"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Temperatuurstijging aflezen",
            "content": "De thermometer wijst −6°C aan. Stijging van 10 graden = optellen: −6 + 10 = 4°C. Je passeert het vriespunt (0°C) en komt op 4°C.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "negatief_plus_thermometer",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De thermometer wijst −6°C aan. De temperatuur stijgt 10 graden: −6 + 10 = 4°C. Je begint 6 graden onder nul en gaat 10 omhoog. Je passeert 0°C en komt 4 graden boven nul uit.",
        "solutionSteps": [
          "Lees de thermometer af: −6°C",
          "Stijging van 10 graden = optellen",
          "−6 + 10 = 4°C",
          "Check: 4 − (−6) = 4 + 6 = 10 graden verschil ✓"
        ]
      }
    }
  ]
}